<template>
    <Teleport v-if="blocked" to="body">
        <div class="edverum-loading-overlay">
            <div class="edverum-loading-backdrop" />
            <div class="edverum-loading-content">
                <ProgressSpinner style="width: 50px; height: 50px" stroke-width="4" animation-duration=".5s" />
                <div v-if="message" class="edverum-loading-message">
                    {{ message }}
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import ProgressSpinner from 'primevue/progressspinner';

export default {
    name: 'GlobalLoading',

    components: {
        ProgressSpinner,
    },

    data() {
        return {
            blocked: false,
            message: null,
            activeLoaders: new Set(),
        };
    },

    mounted() {
        window.addEventListener('primevue-loading-open', this.handleOpen);
        window.addEventListener('primevue-loading-close', this.handleClose);
        window.addEventListener('primevue-loading-close-all', this.handleCloseAll);
    },

    beforeUnmount() {
        window.removeEventListener('primevue-loading-open', this.handleOpen);
        window.removeEventListener('primevue-loading-close', this.handleClose);
        window.removeEventListener('primevue-loading-close-all', this.handleCloseAll);
    },

    methods: {
        handleOpen(event) {
            const { id, message } = event.detail;
            this.activeLoaders.add(id);
            this.message = message;
            this.blocked = true;
        },

        handleClose(event) {
            const { id } = event.detail;
            this.activeLoaders.delete(id);

            if (this.activeLoaders.size === 0) {
                this.blocked = false;
                this.message = null;
            }
        },

        handleCloseAll() {
            this.activeLoaders.clear();
            this.blocked = false;
            this.message = null;
        },
    },
};
</script>

<style scoped lang="scss">
.edverum-loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}

.edverum-loading-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.1);
}

.edverum-loading-content {
    --p-progressspinner-color-one: var(--p-blue-200);
    --p-progressspinner-color-two: var(--p-blue-200);
    --p-progressspinner-color-three: var(--p-blue-200);
    --p-progressspinner-color-four: var(--p-blue-200);

    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.edverum-loading-message {
    margin-top: 1rem;
    color: white;
    font-weight: 500;
    font-size: 0.875rem;
}
</style>
